import { Component, ElementRef, ViewChild, inject } from '@angular/core'
import { PrintElementService } from '@se-po/shared-util'
import { Persona } from 'se-resource-types/dist/lib/UserService'

@Component({
  selector: 'se-po-print-element-service-docs',
  templateUrl: './print-element-service-docs.component.html',
  styleUrls: ['./print-element-service-docs.component.scss'],
  standalone: false,
})
export class PrintElementServiceDocsComponent {
  @ViewChild('profileBarExample') public profileBarExample: ElementRef<HTMLDivElement>
  @ViewChild('personaAvatarExample') public personaAvatarExample: ElementRef<HTMLDivElement>
  @ViewChild('highlightLabelExample') public highlightLabelExample: ElementRef<HTMLDivElement>

  private printElementService = inject(PrintElementService)

  public selfPersona: Persona = {
    id: 5,
    first_name: 'Maame',
    last_name: 'Biney',
    profile_images: [
      {
        image_type: 'crop_icon',
        url: 'https://images.nbcolympics.com/sites/default/files/post/short_form_video/oly22_st_SMD_bineymini__635693.jpg'
      }
    ]
  } as Persona

  public avatarPersona: Persona = {
    id: 101,
    first_name: 'Ava',
    last_name: 'Rivera',
    gender: 'female',
    date_of_birth: '2012-03-15',
    graduation_year: '2030',
    profile_images: [
      {
        image_type: 'crop',
        url: 'https://images.nbcolympics.com/sites/default/files/post/short_form_video/oly22_st_SMD_bineymini__635693.jpg'
      }
    ]
  } as Persona

  public usageTs = `@ViewChild('printSection') public printSection: ElementRef<HTMLDivElement>

constructor(private printElementService: PrintElementService) {}

public print(): void {
  this.printElementService.printElement(this.printSection.nativeElement, {
    printClassName: 'my-component--printing'
  })
}`

  public usageHtml = `<div #printSection class="my-component">
  <!-- printable content -->
</div>

<se-fe-button (click)="print()">Print</se-fe-button>`

  public usageScss = `@media print {
  .my-component--printing .my-component__actions {
    display: none !important;
  }

  .my-component--printing se-fe-card {
    border: 0 !important;
    box-shadow: none !important;
  }
}`

  public printProfileBar(): void {
    this.printExample(this.profileBarExample, 'print-element-service-docs__print-root--profile-bar')
  }

  public printPersonaAvatar(): void {
    this.printExample(this.personaAvatarExample, 'print-element-service-docs__print-root--persona-avatar')
  }

  public printHighlightLabels(): void {
    this.printExample(this.highlightLabelExample, 'print-element-service-docs__print-root--highlight-labels')
  }

  private printExample(elementRef: ElementRef<HTMLDivElement>, printClassName: string): void {
    if (!elementRef?.nativeElement) {
      return
    }

    this.printElementService.printElement(elementRef.nativeElement, { printClassName })
  }
}
